import { useContext, useState, useEffect, Dispatch } from 'react';
import { CardStyled } from '../../../../styles/style';
import ShowImage from '../../../../components/show_image';
import AddPhotosModal from './modals/add_photos_modal';
import { MAXIMUM_IMAGE_FOR_LISTING, RequiredSign } from '../../constants';
import { ProductListingContext } from '../../functions/data_formatting_functions';
import styled from 'styled-components';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import imgloading from '../../../../assets/images/svg/image-loading-icon.svg';
import { toast } from 'react-toastify';
import { S3ApiRepository } from '../../../../data/repositories/s3_repository';
import { StoreDetails } from '../../../../data/types/stores';
import { Colors, Fonts } from '../../../../config/theme';
import { ImageType } from '../../../../data/types/files';
import { ApiRepository } from '../../../../data/repositories/base_repository';
import { ListingState } from '../../../../data/types/listings';
import { UploadImagesModal } from '../../../../pages/image_library/modals/upload_images_modal';
import { Col, Row } from 'antd';
import { FaCheck } from 'react-icons/fa6';
import { IoClose } from 'react-icons/io5';
import { useDispatch } from 'react-redux';
import { actionSetListingData } from '../../../../pages/create_listings/store/create_listing_actions';
import { Button } from '@nextui-org/react';

type MediaProps = {
  addStep: () => void;
  remove: () => void;
  currentStore?: StoreDetails;
  s3Repository: S3ApiRepository;
  filesRepository: ApiRepository;
  actionGetStoreImages?: (payload: any) => { type: string; payload: any };
};

function Media({
  addStep,
  remove,
  currentStore,
  actionGetStoreImages,
  s3Repository,
  filesRepository,
}: MediaProps) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const {
    state,
    dispatch,
  }: {
    state: ListingState;
    dispatch: Dispatch<any>;
  } = useContext(ProductListingContext);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);
  const [index, setIndex] = useState(-1);
  const [image, setImage] = useState<ImageType | null>();

  const nextIndex = (index + 1) % state?.data?.imagesList?.length || 0;
  const nextImage = state?.data?.imagesList?.[nextIndex] || image;
  const prevIndex =
    (index + state?.data?.imagesList?.length - 1) %
    state?.data?.imagesList?.length;
  const prevImage = state?.data?.imagesList?.[prevIndex] || image;

  const openLightBox = (index: number) => {
    setIndex(index);
  };
  useEffect(() => {
    setImage(state?.data?.imagesList[index]);
  }, [index]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClose = () => {
    setImage(null);
    setIndex(-1);
  };
  const handleValidations = () => {
    let error = false;
    if (state.data?.imagesList?.length === 0) {
      toast.warning('Please select at least one image!');
      error = true;
    }
    return error;
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const PhotoStandards = ({
    img1Src,
    img2Src,
    description,
    bothAreWrong = true,
  }: {
    img1Src: string;
    img2Src: string;
    description: React.ReactNode;
    bothAreWrong?: boolean;
  }) => {
    return (
      <Col span={6} className="mt-3 mb-0">
        {' '}
        <Col
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}
        >
          {/* Image 1 with Check Icon */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <ShowImage
              imageSrc={img1Src}
              style={{
                marginBottom: '5px',
                minHeight: '150px',
                maxHeight: '150px',
                minWidth: '150px',
                maxWidth: '150px',
                objectFit: 'scale-down',
              }}
            />
            {bothAreWrong ? (
              <IoClose size={20} color="red" />
            ) : (
              <FaCheck size={20} color={Colors.greenMain} />
            )}
          </div>

          {/* Image 2 with Cross Icon */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <ShowImage
              imageSrc={img2Src}
              style={{
                marginBottom: '5px',
                minHeight: '150px',
                maxHeight: '150px',
                minWidth: '150px',
                maxWidth: '150px',
                objectFit: 'scale-down',
              }}
            />
            <IoClose size={20} color="red" />
          </div>
        </Col>
        {/* Description */}
        <Col>{description}</Col>
      </Col>
    );
  };
  console.log('media stat.data', state.data);
  return (
    <div>
      {image && (
        <Lightbox
          mainSrc={image.public_s3_url}
          imageTitle={image.alt}
          mainSrcThumbnail={image.public_s3_url}
          nextSrc={nextImage.public_s3_url}
          nextSrcThumbnail={nextImage.alt}
          prevSrc={prevImage.public_s3_url}
          prevSrcThumbnail={prevImage.alt}
          onCloseRequest={handleClose}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}
      <Wrapper>
        <div className="flex flex-col">
          <CardStyled style={{ padding: '15px 20px' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <h6
                style={{
                  fontWeight: 700,
                }}
              >
                Requirements for{' '}
                <span
                  style={{
                    color: Colors.greenMain,
                  }}
                >
                  NEW
                </span>{' '}
                photos
              </h6>
              <UploadImagesModal
                postAddAltsCallback={() => {}}
                postSuccessfullUploadCallback={({ imagesObjects }) => {
                  console.log('imagesObjects', imagesObjects);
                  const new_imagesList =
                    state.data?.imagesList.concat(imagesObjects);
                  dispatch(
                    actionSetListingData({
                      ...state.data,
                      images: new_imagesList.map((img: any) => img?.id),
                      imagesList: new_imagesList,
                      notToUploadImages: [],
                    }),
                  );
                }}
                getData={() => {}}
                store_id={currentStore?.id?.toString()}
                maxImages={MAXIMUM_IMAGE_FOR_LISTING}
                s3Repository={s3Repository}
                filesRepository={filesRepository}
                variant="solid"
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={imgloading}
                    width={200}
                    height={200}
                    style={{
                      marginRight: 20,
                      borderRadius: 5,
                    }}
                  />
                  <div>
                    <p
                      style={{
                        fontSize: 12,
                        color: Colors.alternateText,
                        fontWeight: 600,
                        marginTop: 20,
                        marginLeft: 5,
                      }}
                    >
                      Add images for{' '}
                      <span
                        style={{
                          color: Colors.greenMain,
                        }}
                      >
                        {state.data?.name_en}
                      </span>{' '}
                      or its variations only.
                    </p>
                    <p
                      style={{
                        fontSize: 12,
                        color: Colors.alternateText,
                        fontWeight: 600,
                        marginLeft: 5,
                      }}
                    >
                      Format: JPEG, PNG, JPG.
                    </p>
                    <p
                      style={{
                        fontSize: 12,
                        color: Colors.alternateText,
                        fontWeight: 600,
                        marginLeft: 5,
                      }}
                    >
                      Size: does not exceed 20 MB.
                    </p>
                  </div>
                </div>
                <PhotoStandards
                  img1Src={
                    'https://silal-file-store.s3.il-central-1.amazonaws.com/s3_images/uploaded_objects/silal/16780.png?versionId=CnlILWLXQDyfIy9vt5CD6S3mxovmv7fq'
                  }
                  img2Src={
                    'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1204.jpeg?versionId=A.HVN5u374hQatYEDj.UKD00lAf2inSd'
                  }
                  bothAreWrong={false}
                  description={
                    <p
                      style={{
                        fontSize: 12,
                        color: Colors.alternateText,
                        fontWeight: 600,
                        marginTop: 20,
                        marginLeft: 5,
                        whiteSpace: 'pre-wrap', // Ensures multi-line text
                        textAlign: 'center', // Center text under images
                      }}
                    >
                      The cover image must have a{' '}
                      <span
                        style={{
                          color: Colors.greenMain,
                        }}
                      >
                        transparent or white background
                      </span>
                      .
                      <br /> Cover image must be{' '}
                      <span
                        style={{
                          color: Colors.greenMain,
                        }}
                      >
                        square shape
                      </span>
                      .
                    </p>
                  }
                />{' '}
                <PhotoStandards
                  img1Src={
                    'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1203.jpeg?versionId=.8KDWJABG1Ivrzu_Bji5sE6f2OTRnvS6'
                  }
                  img2Src={
                    'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1202.png?versionId=HuQ7Jf1JlgIvL6b3Q9wywAPl8jcK3s75'
                  }
                  description={
                    <p
                      style={{
                        fontSize: 12,
                        color: Colors.alternateText,
                        fontWeight: 600,
                        marginTop: 20,
                        marginLeft: 5,
                        whiteSpace: 'pre-wrap', // Ensures multi-line text
                        textAlign: 'center', // Center text under images
                      }}
                    >
                      Product in image must be{' '}
                      <span
                        style={{
                          color: Colors.greenMain,
                        }}
                      >
                        centered.
                      </span>{' '}
                      <br />
                      Must have margin and take
                      <span
                        style={{
                          color: Colors.greenMain,
                        }}
                      >
                        {' '}
                        70%
                      </span>{' '}
                      of the image.
                    </p>
                  }
                />{' '}
                <PhotoStandards
                  img1Src={
                    'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1199.jpeg?versionId=zs52igD1Pzq.kCpoqOpCZE85.VB0csBl'
                  }
                  img2Src={
                    'https://development-image-store-silal.s3.eu-central-1.amazonaws.com/s3_images/uploaded_objects/silal/1205.jpeg?versionId=vvdFexVCf9sUa_pmONy6quWXKyquwE4A'
                  }
                  description={
                    <p
                      style={{
                        fontSize: 12,
                        color: Colors.alternateText,
                        fontWeight: 600,
                        marginTop: 20,
                        marginLeft: 5,
                        whiteSpace: 'pre-wrap', // Ensures multi-line text
                        textAlign: 'center', // Center text under images
                      }}
                    >
                      Images mustn't have any{' '}
                      <span
                        style={{
                          color: Colors.greenMain,
                        }}
                      >
                        watermarks or offers
                      </span>
                      .<br />
                      Images doesn't include{' '}
                      <span
                        style={{
                          color: Colors.greenMain,
                        }}
                      >
                        other products or humans.
                      </span>
                      .
                    </p>
                  }
                />
              </div>
            </div>
            <p
              className="mt-2"
              style={{
                fontSize: 12,
                color: Colors.alternateText,
                fontWeight: 600,
              }}
            >
              <span style={{ color: '#05AE4B' }}> Please note:</span> If you
              have special attributes that have images, please upload their
              images too.
            </p>
          </CardStyled>
          <CardStyled style={{ padding: '15px 20px' }}>
            <div className="header flex row">
              <div className="media col">
                <h5
                  style={{
                    fontWeight: 700,
                  }}
                >
                  Current Media{' '}
                  <span>
                    {state?.data?.imagesList?.length || 0}/
                    {MAXIMUM_IMAGE_FOR_LISTING}
                  </span>
                  {RequiredSign()}
                </h5>
              </div>
              <div className="butn col end mb-2">
                <Button
                  onClick={() => setIsModalVisible(!isModalVisible)}
                  variant="light"
                  color={'success'}
                  style={{
                    background: 'none',
                  }}
                >
                  Hide, Remove or Set Cover Images
                </Button>
              </div>
            </div>
            <div className="grid-container">
              {Array.from({ length: MAXIMUM_IMAGE_FOR_LISTING }, (_, i) => ({
                id: i,
              })).map((_, index) => {
                return (
                  <div key={index}>
                    {state.data?.images[index] ? (
                      <div className="media_image">
                        <ShowImage
                          image={state.data?.imagesList[index]}
                          style={{
                            objectFit: 'scale-down',
                            width: '100px',
                            height: '100px',
                          }}
                          onClick={() => {
                            openLightBox(
                              // state.data?.imagesList[index],
                              index,
                            );
                          }}
                        />
                      </div>
                    ) : (
                      <div className="media_image" />
                    )}
                  </div>
                );
              })}
            </div>

            <div className=" flex  justify-between">
              <Button onPress={remove}>Back</Button>{' '}
              <Button
                onPress={
                  handleValidations()
                    ? () => {}
                    : () => {
                        addStep();
                      }
                }
                color={'success'}
                style={{
                  width: '150px',
                }}
              >
                Next step
              </Button>
            </div>
          </CardStyled>
        </div>

        <AddPhotosModal
          actionGetStoreImages={actionGetStoreImages}
          currentStore={currentStore}
          isModalVisible={isModalVisible}
          setPhotoBarModal={handleOk}
          handleCancel={handleOk}
          s3Repository={s3Repository}
          filesRepository={filesRepository}
          selection={false}
          selectedImage={undefined}
          addOrSelectActionsOnly={false}
        />
      </Wrapper>
    </div>
  );
}
export default Media;

const Wrapper = styled.div`
  p {
    margin: 2px;
    color: ${Colors.alternateText};
    font-family: ${Fonts.secondary};
  }
  .delete {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    background-color: #555;
    color: white;
    font-size: 16px;
    padding: 12px 24px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }
  font-family: 'Poppins';
  font-style: normal;
  .padding {
    padding: 0px 20px;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .left {
    /* border: 1px solid #000; */
    .header {
      padding: 0px 20px;
      border-bottom: 1px solid rgba(0, 39, 51, 0.08);
    }
    .butn {
      float: right;
    }
    p {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #002733;
      span {
        color: rgba(0, 39, 51, 0.3);
      }
    }
  }
  .grid-container {
    display: grid;
    grid-template-columns: auto auto auto auto auto auto;
    gap: 10px;
    padding: 25px 0px;
  }

  .grid-container > div {
    background-color: #f4f7f8;
    border-radius: 5px;
    text-align: center;
    font-size: 12px;
    width: 100%;
    height: 100%;
    min-height: 100px;
    max-height: 100px;
    max-width: 100px;
    min-width: 100px;
  }

  .media_image {
    margin-top: auto;
    margin-bottom: auto;
  }
  .cover {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 3;
    height: 100%;
    padding: 50px 0% 0px 0px;
  }
  .footer {
    padding: 0px 20px;
    .back {
      border: 1px solid #05ae4b;
      border-radius: 5px;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box !important;
    padding: 15px 20px;
    margin-bottom: 20px;
    background: #ffffff;
    box-shadow: 0px 5px 10px -2px rgba(196, 214, 220, 0.25);
    border-radius: 5px;
    .img_div {
      width: 120px;
    }
    img {
      width: 100px;
    }
    h6 {
      padding: 5px;
      font-weight: 700;
      font-size: 16px;
      color: #002733;
    }
    h5 {
      font-weight: 400;
      font-size: 13px;
      line-height: 130%;
      color: rgba(0, 39, 51, 0.5);
      padding-left: 21px;
    }
    p {
      font-weight: 600;
      font-size: 9px;
      color: #05ae4b;
      margin-top: 5px;
    }
  }
  .item {
    text-align: center;
    margin-bottom: 10px;
  }
`;
